import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "popup__flex-box" }
const _hoisted_2 = { class: "popup__close" }
const _hoisted_3 = {
  key: 0,
  class: "popup__title-box"
}
const _hoisted_4 = ["innerHTML"]

import { onBeforeUnmount, onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePopup',
  props: {
    title: {},
    compact: { type: Boolean },
    closeEvent: { type: Function }
  },
  emits: ['hide'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const visible = ref(false)

onMounted(() => {
  // We're using a global event listener here instead of `@keydown`,
  // because we would have to put `@keydown` on every level of the component
  // hierarchy to handle every possible focus.
  document.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeydown)
})

function handleKeydown(keydownEvent: KeyboardEvent): void {
  if (keydownEvent.key === 'Escape') {
    hide()
  }
}

function show(): void {
  visible.value = true
}

function hide(sendEvent: boolean = true): void {
  visible.value = false
  if (sendEvent && props.closeEvent) {
    props.closeEvent()
  }
  emit('hide')
}

function isVisible(): boolean {
  return visible.value
}

__expose({
  show,
  hide,
  isVisible,
})

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["popup v-fade", { 'popup--compact': __props.compact }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (hide()))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "popup__content",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($event.stopPropagation()))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (hide()))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "popup__close-icon iconfont iclose" }, null, -1)
              ]))])
            ]),
            (__props.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h2", {
                    class: "popup__title",
                    innerHTML: __props.title
                  }, null, 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})